import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper';
import ListHeader from '@/common/components/ListHeader';
import { FileSpreadsheetIcon } from 'lucide-react';
import { usePermittedReports } from '../../hooks/usePermittedReports';
import Skeleton from '@/common/components/Skeleton';
import { EmptyDataMessage } from '@/common/components/EmptyDataMessage';
import ReportsGridItem from '../../components/ReportsGridItem';
import { ReportsMineData } from '../../types/reportsMine.type';

const ReportsPermittedReports = () => {
  const { 
    data: permittedReports,
    error: permittedReportsError = {} as any,
    isPending: permittedReportsIsPending,
    refetch: permittedReportsRefetch
  } = usePermittedReports<ReportsMineData[]>({});

  return (
    <div className="flex flex-col gap-6">
      <ListHeader Icon={<FileSpreadsheetIcon className="w-10 h-10" strokeWidth={1} />} title="Relatórios" />

      <ErrorMessageWrapper 
        className="max-h-[calc(100vh-128px)]"
        statusCode={permittedReportsError?.status}
        refetchFunction={permittedReportsRefetch}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          {permittedReportsIsPending && (
            <div className="grid grid-cols-1 md:grid-cols-[repeat(auto-fill,minmax(350px,2fr))] gap-4 overflow-y-auto max-h-[calc(100vh-232px)]">
              {new Array(10).fill(null).map((_, i) => (
                <Skeleton key={`loading_document_${i}`} height={200} className="bg-white-100 rounded-lg " />
              ))}
            </div>
          )}

          {!permittedReportsIsPending && permittedReports.length === 0 && (
            <EmptyDataMessage className="h-[calc(100vh-232px)]" />
          )}

          {!permittedReportsIsPending && permittedReports.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-[repeat(auto-fill,minmax(350px,2fr))] gap-4 overflow-y-auto h-auto">
              {permittedReports.map((report) => (
                <ReportsGridItem key={report.id} report={report} />
              ))}
            </div>
          )}
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default ReportsPermittedReports;
